import React from "react";
import styled from "styled-components";

import {
  problemComplexities,
  ProblemComplexityKey,
} from "../../../common/types/query_domain";

import {ScoreAnalysis} from "../types";
import {BatchId, LlmRunBatchInfo} from "common/flowmaster/types/llm_run";

type Props = {
  batchScores: Record<ProblemComplexityKey, Record<BatchId, ScoreAnalysis>>;
  batches: LlmRunBatchInfo[];
  showAnalysis: (item: ScoreAnalysis) => void;
};

const ColumnHeader = styled.th`
  padding: 0 0.5em;
`;

export default function BatchResults({
  batchScores,
  batches,
  showAnalysis,
}: Props) {
  return (
    <table>
      <thead>
        <tr>
          <th>Batch</th>
          <th>Issues</th>
          {problemComplexities.map(complexity => (
            <th key={complexity}>{complexity}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Object.entries(batchScores).map(
          ([batchId, problemComplexityScores]) => (
            <tr key={batchId}>
              <ColumnHeader>{batchId}</ColumnHeader>
              <ColumnHeader>
                {(
                  batches.find(batch => batch.batch_id === batchId)
                    ?.different_issues ?? []
                ).map(issue => (
                  <span key={issue.id}>{issue.name}</span>
                ))}
              </ColumnHeader>
              <>
                {problemComplexities.map(pComplexity => {
                  const item = problemComplexityScores[pComplexity];
                  return (
                    <td onClick={() => showAnalysis(item)} key={pComplexity}>
                      {problemComplexityScores[pComplexity]?.score ?? "-"}
                    </td>
                  );
                })}
              </>
            </tr>
          ),
        )}
      </tbody>
    </table>
  );
}
